// TopMenu.jsx
// import React from "react";
import React, { useContext,useState } from "react";
import { useLocation } from "react-router-dom";
//import React, { useState } from "react";
import { FaUserCircle, FaRobot } from "react-icons/fa"; 
import { Navbar, Nav, Dropdown, Container } from "react-bootstrap";
import { PersonCircle, BoxArrowRight, List } from "react-bootstrap-icons";
import api from "../jsx/axiosClient";

import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../jsx/UserContext";

export default function TopMenu({ active = "home", onSelect = ()=>{} }) {
     const navigate = useNavigate();
  const { userSession, setUserSession } = useContext(UserContext);
  const [expanded, setExpanded] = useState(false);
const location = useLocation();
const handleLogoutClick = async () => {
  Swal.fire({
    title: "Are you sure?",
    text: "You will be logged out of your session.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, Logout",
    cancelButtonText: "Cancel",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
//         const response = await fetch("/logout", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${userSession?.access_token}`,
//           },
//         });
// console.log("response",response)
//         if (!response.ok) {
//           throw new Error("Logout failed");
//         }
//         setUserSession({ name: "", access_token: "" });
//         Swal.fire({
//           title: "Logged Out!",
//           text: "You have been logged out successfully.",
//           icon: "success",
//           timer: 1500,
//           showConfirmButton: false,
//         }).then(() => {
//    localStorage.removeItem("userSession");
//   setUserSession(null);
//   navigate("/login", { replace: true });
//         });

  const response = await api.post("/logout",);
      const result = response.data;
      console.log("logout:",result)
if (result.status === "success") {
  setUserSession({ name: "", access_token: "" });
        Swal.fire({
          title: "Logged Out!",
          text: result.message,
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
   localStorage.removeItem("userSession");
  setUserSession(null);
  navigate("/login", { replace: true });
        });

}
 else {
        Swal.fire({ icon: "error", title: "Login Failed", text: result.message });
      }




      } catch (error) {
        console.error("Logout error:", error);
        Swal.fire({
          title: "Error!",
          text: "Failed to log out. Please try again.",
          icon: "error",
          confirmButtonColor: "#3085d6",
        });
      }

    }
  });
};

  return (

//    <div className="top-menu-react">
//       <Nav className="ms-auto justify-content-end align-items-center py-2 px-4 w-100">
//         <Nav.Item>
//            <Nav.Link active={active === "home"}   onClick={() => {
//               navigate("/dashboard");
//             }}
// >
//             Home
//           </Nav.Link>
//         </Nav.Item>

//         <Nav.Item>
//           <Nav.Link active={active === "audiodescribe"}  onClick={() => {
//               navigate("/fileupload");
//             }}
// >
//             Audio Describe
//           </Nav.Link>
//         </Nav.Item>
//   <Nav.Item>
//           <Nav.Link active={active === "islvideo"}  onClick={() => {
//               navigate("/islvideo");
//             }}
// >
//             ISL Video 
//           </Nav.Link>
//         </Nav.Item>
      
//         {/* ✅ User Dropdown aligned right */}
//         <Nav.Item className="ms-3">
//           <Dropdown align="end">
//             <Dropdown.Toggle
//               variant="link"
//               className="p-0 user-icon-btn"
//               aria-label="User Menu"
//             >
//               <PersonCircle size={30} color="white" />
//             </Dropdown.Toggle>

//             <Dropdown.Menu className="shadow-sm">
//               <div className="px-3 py-2 border-bottom">
//                 <div className="fw-semibold">{userSession?.name || "Guest"}</div>
//                 <small className="text-muted">{userSession?.email || ""}</small>
//               </div>

//               <Dropdown.Item onClick={() => navigate("/profile")}>
//                 My Profile
//               </Dropdown.Item>

//               <Dropdown.Divider />

//               <Dropdown.Item onClick={handleLogoutClick} className="text-danger fw-semibold">
//                 <BoxArrowRight size={16} color="white" /> Logout
//               </Dropdown.Item>
//             </Dropdown.Menu>
//           </Dropdown>
//         </Nav.Item>
//       </Nav>

//       <style jsx>{`
//         .top-menu-react {
//           background: rgb(176, 0, 78);
//           box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
//           position: sticky;
//           top: 0;
//           z-index: 1050;
//         }

//        .nav-link {
//   padding: 8px 16px;
//   border-radius: 4px;
//   font-weight: 600;
//   color: white;
// }

// /* Hover effect: light underline and maroon text */
// .nav-link:hover {
//   color: black !important;
//   text-decoration: none;
// }

// /* ✅ ACTIVE — Only text color change */
// .nav-link.active {
//   color: white !important;
//   background: transparent !important;
//   box-shadow: none !important;
//   text-decoration: none;
// }


//         .user-icon-btn {
//           background: transparent !important;
//           border: none !important;
//         }
//       `}</style>
//     </div>

<div>
<style jsx>{`
  .top-menu-react {
    background: #5C64A6 !important; /* Your primary purple/blue */
    padding: 0.6rem 1rem;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    position: sticky;
    top: 0;
    z-index: 1050;
  }

  .nav-link {
    color: rgba(255, 255, 255, 0.8) !important;
    font-weight: 500;
    padding: 8px 20px !important;
    border-radius: 50px; /* Pill shape */
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    margin: 0 5px;
  }

  /* Hover state: subtle background */
  .nav-link:hover {
    color: #ffffff !important;
    background: rgba(255, 255, 255, 0.1);
  }

  /* ✅ MODERN ACTIVE STATE: White Pill with Dark Text */
  .nav-link.active {
    color: #5C64A6 !important; /* Text matches navbar color */
    background: #ffffff !important; /* Bright white capsule */
    font-weight: 700;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    transform: translateY(-1px); /* Slight lift */
  }

  /* Small indicator dot for active tab on mobile */
  @media (max-width: 991px) {
    .nav-link.active {
      transform: none;
      margin: 5px 0;
    }
  }

  /* User Icon Styling */
  .user-icon-btn {
    transition: transform 0.2s ease;
  }
  .user-icon-btn:hover {
    transform: scale(1.1);
  }
`}</style>
      <Navbar
        expand="md"
        expanded={expanded}
        className="top-menu-react"
        variant="dark"
      >
        <Container fluid>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            onClick={() => setExpanded(!expanded)}
            className="border-0"
          >
            <List size={28} color="white" />
          </Navbar.Toggle>
<Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto align-items-center gap-3 gap-lg-5 py-3 py-md-0"> 
<Nav.Link
  active={location.pathname === "/dashboard"}
  onClick={() => {
    navigate("/dashboard");
    setExpanded(false);
  }}
>
  Home
</Nav.Link>

<Nav.Link
  active=
  {location.pathname === "/fileupload" ||
location.pathname === "/Fileupload" 
  }
  onClick={() => {
    navigate("/fileupload");
    setExpanded(false);
  }}
>
  Audio Description
</Nav.Link>

<Nav.Link
  active={
  location.pathname === "/Isldashboard" ||
  location.pathname === "/Islvideo" ||
  location.pathname === "/IslLive"
}
  onClick={() => {
    navigate("/Isldashboard");
    setExpanded(false);
  }}
>
  Indian Sign Language Translation
</Nav.Link>
  </Nav>

  <div className="d-flex justify-content-center mt-2 mt-md-0">
    <Dropdown align="end" className="user-dropdown">
      <Dropdown.Toggle
        variant="link"
        className="p-0 user-icon-btn"
        aria-label="User Menu"
      >
        <PersonCircle size={30} color="white" />
      </Dropdown.Toggle>
      <Dropdown.Menu className="shadow-lg border-0 mt-2">
        <div className="px-3 py-2 border-bottom">
          <div className="fw-bold">{userSession?.name || "Guest"}</div>
          <small className="text-muted">{userSession?.email || ""}</small>
        </div>
        <Dropdown.Item onClick={() => navigate("/profile")}>
          My Profile
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item
          onClick={handleLogoutClick}
          className="text-danger fw-semibold"
        >
          <BoxArrowRight size={18} className="me-2" /> Logout
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  </div>
</Navbar.Collapse>       
      </Container>
      </Navbar>
</div>
  );
}
